import { ErrorHandler, Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { ThemeService } from '@wind-log_library/fe-component-library';
import { take } from 'rxjs/operators';
import { VersionService } from '../shared/services/version-service/version.service';
import { LogoutService } from 'app/shared/services/logout-service/logout.service';
import { Subject } from 'rxjs';
import { BsModalService } from 'ngx-bootstrap/modal';
import { NewApplicationVersionPopupComponent } from 'app/shared/components/new-application-version-popup/new-application-version-popup.component';
import { UserProfileService } from 'app/shared/user-profile/user-profile.service';

@Injectable({
  providedIn: 'root'
})

export class GlobalErrorHandler implements ErrorHandler {

  private e: ErrorDataInterface = { application: 'Horizon Wind', type: '', message: '', stack: '', url: '', user: '', version: '', browser: '', screenResolution: '', config: { theme: '', lang: ''}};

  /* Add in this list the MESSAGE field of the errors we don't want to send to the slack channel */
  private errorMessagesSkipped = [
    'Not authorised!',
    'Uncaught (in promise): Failed to refresh the token, or the session is expired'
  ];

  constructor(
    private userProfileService: UserProfileService,
    private translateService: TranslateService,
    private themeService: ThemeService,
    private versionService: VersionService,
    private logoutService: LogoutService,
    private modalService: BsModalService
  ) {}

  public async handleError(error: any) {
    console.error(error);
    /* Temporary disable sending errors to slack */
    const disableErrorLogging = false;
    if (disableErrorLogging) {
      return;
    }
    /* Automatically logout when auth token is expired*/
    if (error?.hasOwnProperty('message') && (error?.message === 'Not authorised!' || error?.message === 'TokenExpiredError: jwt expired')) {
      this.logoutService.logout();
      return;
    }
    if (!environment.production || environment.integration) {
      return;
    }
    if (window.location.href.includes('localhost')) {
      return;
    }
    if (error instanceof ErrorEvent) {
        this.e.type = error?.type;
        this.e.message = error?.message;
        this.e.stack = String(error?.target);
    } else {
        this.e.type = error?.name;
        this.e.message = error?.message;
        this.e.stack = error?.stack;
    }
    if (this.errorMessagesSkipped.includes(this.e.message)) {
      return;
    }
    // this.getUserData();
    // await this.getCurrentConfig();
    // await this.sendErrorData(this.e);
  }

  // private getUserData(): void {
  //   if (environment.auth_enabled) {
  //     const profile = this.userProfileService.getUserProfile();
  //     this.e.user = profile?.username ?? 'undefined';
  //   }
  // }


  // private async getCurrentConfig() {
  //   try {
  //     this.e.version = this.versionService.getFormattedVersion();
  //     this.e.browser = navigator.userAgent;
  //     this.e.screenResolution = `${window.innerWidth} x ${window.innerHeight}`;
  //     this.e.url = window.location.href;
  //     this.e.config.theme = await this.themeService.getTheme().pipe(take(1)).toPromise();
  //     this.e.config.lang = this.translateService.currentLang;
  //   } catch (e) {}
  // }

  // private async sendErrorData(data: ErrorDataInterface) {
  //   const dataString = {data: `* *Application:* ${data.application}\n\n* * *URL:* ${data.url}\n\n* *Type:* ${data.type}\n\n* *Message:* ${data.message}\n\n* *Detail:* ${data.stack}\n\n* *Wind-log Version:* ${data.version}\n\n\n *More info:*\n- _User:_ ${data.user}\n- _Theme:_ ${data.config.theme}\n- _Lang:_ ${data.config.lang}\n- _Browser:_ ${data.browser}\n- _Screen resolution:_ ${data.screenResolution}\n`};
  //   await (fetch(
  //     environment.horizonPostErrorServerURL, {
  //       method: 'POST',
  //       headers: {'Content-Type': 'application/json'},
  //       body: JSON.stringify(dataString)
  //     }))
  //     .then((response) => { response.json(); })
  //     .catch((err) => { console.error('Error', err); }
  //   );
  // }
  
  public async handleErrorManually(error: any) {
    console.error(error);
    /* Custom case for navigation error */
    this.e.type = 'Navigation Error';
    this.e.message = error?.error?.stack;
    this.e.stack = error?.target?.url || error?.url;
    // await this.getUserData();
    // await this.getCurrentConfig();
    // await this.sendErrorData(this.e);
  }

  public async handleAppVersionError(error) {
    const subject = new Subject<any>();
    const modal = this.modalService.show(NewApplicationVersionPopupComponent, {
      backdrop: true,
      keyboard: false,
      ignoreBackdropClick: true,
      class: `modal-dialog-primary modal-sm modal-dialog-centered ${this.themeService.getTheme().value}`
    });

    modal.content.subject = subject;

    subject.toPromise().then(() => {
      const targetUrl = window.location.origin + ((error?.target?.url || error?.url) ?? '');
      window.location.href = targetUrl;
    });
  }
}

export interface ErrorDataInterface {
  application: string;
  type: string;
  message: string;
  stack: string;
  url: string;
  user: string;
  version: string;
  browser: string;
  screenResolution: string;
  config: { theme: string, lang: string};
}
